import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=ff2e4294&scoped=true&"
import script from "./customer.vue?vue&type=script&lang=ts&"
export * from "./customer.vue?vue&type=script&lang=ts&"
import style0 from "./customer.vue?vue&type=style&index=0&id=ff2e4294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2e4294",
  null
  
)

export default component.exports